import { ThemeUIStyleObject } from 'theme-ui';

export const root: ThemeUIStyleObject = {
  flex: '1 1 0',
  overflow: 'hidden',
};
